// src/hooks/useApiKey.js
import { useEffect, useState, useCallback } from "react";
import axios from "axios";

const AUTH_API_URL = process.env.REACT_APP_AUTH_URL;
const APP_USER = process.env.REACT_APP_USER;
const APP_PASS = process.env.REACT_APP_PASS;

const useApiKey = () => {
  const [key, setKey] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const reload = useCallback(() => {
    setKey(null);
    setError(null);
    setIsLoading(false);
  }, []);

  useEffect(() => {
    if (!isLoading && !key && !error) {
      setIsLoading(true);
      // Use a plain fetch so it bypasses the axios interceptor entirely —
      // the auth call must always go directly to AUTH_API_URL unmodified.
      fetch(AUTH_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username: APP_USER, password: APP_PASS }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data?.token) {
            console.log("API Key obtained successfully");
            setKey(data.token);
            setIsLoading(false);
          } else {
            console.warn("Auth response missing token:", data);
            setIsLoading(false);
            setError("missing API key token");
          }
        })
        .catch((err) => {
          console.error("API Key Error:", err);
          setError("Error loading API key.");
          setIsLoading(false);
        });
    }
  }, [key, error, isLoading]);

  return [key, isLoading, error, reload];
};

export default useApiKey;
